import React, { useState, useEffect } from 'react';
import { Container, Card, Row, Col, Button, Table, Badge, Form, InputGroup, Modal, Spinner, ProgressBar } from 'react-bootstrap';
import { PDFDocument } from 'pdf-lib';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';

const styles = {
  appContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f0f4f8',
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    borderBottom: '2px solid #0d9488',
    padding: '0 1rem',
    height: '48px'
  },
  navLinkCustom: {
    color: 'rgba(255,255,255,0.65)',
    fontSize: '0.75rem',
    fontWeight: '500',
    padding: '0.25rem 0.6rem',
    borderRadius: '6px',
    transition: 'all 0.2s',
    display: 'flex',
    alignItems: 'center',
    gap: '0.35rem',
    textDecoration: 'none'
  },
  navLinkActive: {
    color: '#fff',
    backgroundColor: 'rgba(255,255,255,0.1)',
    fontWeight: '600',
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  }
};

const getMenuIcon = (title) => {
  const t = title.toLowerCase();
  if (t.includes('obat') || t.includes('stok') || t.includes('ttb')) return 'bi-box-seam';
  if (t.includes('kamar') || t.includes('bed')) return 'bi-hospital';
  if (t.includes('pasien') || t.includes('rm')) return 'bi-person-badge';
  if (t.includes('klaim') || t.includes('bpjs')) return 'bi-shield-check';
  if (t.includes('tagihan') || t.includes('kasir') || t.includes('poliklinik') || t.includes('polikonik')) return 'bi-receipt';
  if (t.includes('dokter') || t.includes('medis')) return 'bi-bandaid';
  if (t.includes('lab') || t.includes('rad') || t.includes('penunjang')) return 'bi-heart-pulse';
  if (t.includes('user') || t.includes('admin')) return 'bi-people';
  return 'bi-folder2';
};

const getApiUrl = () => {
  return localStorage.getItem('apiUrl') || 'http://localhost:8000';
};

const PoliKlinik = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [username] = useState('Administrator');
  const [menus, setMenus] = useState([]);
  const [, setActiveMenu] = useState('');
  const [time, setTime] = useState({ date: '', clock: '' });
  const [isNavOpen, setIsNavOpen] = useState(false);

  // Form State
  const [noMedrec, setNoMedrec] = useState('');
  const [namaPasien, setNamaPasien] = useState('');
  const [dokterPasien, setDokterPasien] = useState('');
  const [, setKdDokter] = useState('');
  const [listDokter, setListDokter] = useState([]);
  const dokterOptions = listDokter.map(d => ({ value: d.nodok, label: d.nama_dok }));
  const [isLoadingDokter, setIsLoadingDokter] = useState(false);
  const [listKelompok, setListKelompok] = useState([]);
  const kelompokOptions = listKelompok.map(k => ({ value: k.kd_kelompok, label: k.nm_kelompok }));
  const [isLoadingKelompok, setIsLoadingKelompok] = useState(false);
  const [penjaminPasien, setPenjaminPasien] = useState('');
  const [klasifikasiPasien, setKlasifikasiPasien] = useState('');
  const [kdKlasifikasi, setKdKlasifikasi] = useState('');
  const [, setKdKelas] = useState('');
  const [selectedKelompok, setSelectedKelompok] = useState(null);
  const [selectedDokter, setSelectedDokter] = useState(null);
  const [selectedTindakan, setSelectedTindakan] = useState(null);
  const [inputQty, setInputQty] = useState(1);
  const [showModalTindakan, setShowModalTindakan] = useState(false);
  const [searchTindakanQuery, setSearchTindakanQuery] = useState('');
  const [listTindakan, setListTindakan] = useState([]);
  const [isLoadingTindakan, setIsLoadingTindakan] = useState(false);
  const [caraBayar, setCaraBayar] = useState('');

  // Modal State
  const [showModalPasien, setShowModalPasien] = useState(false);
  const [showModalTransaksi, setShowModalTransaksi] = useState(false);
  const [showModalTT, setShowModalTT] = useState(false);
  const [inputNoTT, setInputNoTT] = useState('');
  
  // Transaksi List State
  const [listTransaksi, setListTransaksi] = useState([]);
  const [isLoadingTransaksi, setIsLoadingTransaksi] = useState(false);

  useEffect(() => {
    if (noMedrec) {
      const fetchTransaksi = async () => {
        setIsLoadingTransaksi(true);
        try {
          const res = await fetch(`${getApiUrl()}/show_transaksirj?no_medrec=${noMedrec}`);
          const json = await res.json();
          // Backend returns list_rincian or list_rincain based on the example
          if (json.status === 1 && (json.list_rincian || json.list_rincain)) {
            setListTransaksi(json.list_rincian || json.list_rincain);
          } else {
            setListTransaksi([]);
          }
        } catch (err) {
          console.error('Gagal mengambil data transaksi:', err);
          setListTransaksi([]);
        } finally {
          setIsLoadingTransaksi(false);
        }
      };
      fetchTransaksi();
    } else {
      setListTransaksi([]);
    }
  }, [noMedrec]);

  const subTotal = listTransaksi.reduce((sum, item) => sum + (item.total || 0), 0);
  const diskon = 0; // TBD
  const totalTagihan = subTotal - diskon;


  const handleProsesTT = () => {
    // TODO: Integrate with backend endpoint for TT later
    console.log("Mencari transaksi TT:", inputNoTT);
    setShowModalTT(false);
    setInputNoTT('');
  };
  const [listPasien, setListPasien] = useState([]);
  const [isLoadingPasien, setIsLoadingPasien] = useState(false);
  const [searchPasienQuery, setSearchPasienQuery] = useState('');

  useEffect(() => {
    const savedMenu = localStorage.getItem('mainmenu');
    if (savedMenu) {
      const parsedMenu = JSON.parse(savedMenu);
      setMenus(parsedMenu);
      if (parsedMenu.length > 0) setActiveMenu(parsedMenu[0].id_mn);
    }

    const fetchDokter = async () => {
      setIsLoadingDokter(true);
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${getApiUrl()}/show_dokter?token=${encodeURIComponent(token)}`);
        const json = await res.json();
        if (json.list_dokter && Array.isArray(json.list_dokter)) {
           setListDokter(json.list_dokter);
        } else if (json.data && Array.isArray(json.data)) {
           setListDokter(json.data);
        } else if (Array.isArray(json)) {
           setListDokter(json);
        } else if (json.status === 1) {
           // fallback just in case data is in another property
           setListDokter(json.data || []);
        }
      } catch (err) {
        console.error('Gagal mengambil data dokter:', err);
      } finally {
        setIsLoadingDokter(false);
      }
    };
    fetchDokter();

    
    const fetchKelompok = async () => {
      setIsLoadingKelompok(true);
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${getApiUrl()}/show_kelompok?token=${encodeURIComponent(token)}`);
        const json = await res.json();
        if (json.list_kelompok && Array.isArray(json.list_kelompok)) {
           setListKelompok(json.list_kelompok);
        } else if (json.data && Array.isArray(json.data)) {
           setListKelompok(json.data);
        } else if (Array.isArray(json)) {
           setListKelompok(json);
        } else if (json.status === 1) {
           setListKelompok(json.data || []);
        }
      } catch (err) {
        console.error('Gagal mengambil data kelompok:', err);
      } finally {
        setIsLoadingKelompok(false);
      }
    };
    fetchKelompok();

    const updateTime = () => {
      const now = new Date();
      const optionsDate = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      const dateString = now.toLocaleDateString('id-ID', optionsDate);
      const clockString = now.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      setTime({ date: dateString, clock: clockString });
    };

    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  const fetchDaftarPasien = async () => {
    setIsLoadingPasien(true);
    setListPasien([]);
    try {
      const d = new Date();
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      const today = `${dd}/${mm}/${yyyy}`;

      const res = await fetch(`${getApiUrl()}/show_pasienrj?periode=${today}&periode2=${today}`);
      const json = await res.json();
      if (json.list_pasienrj) {
        setListPasien(json.list_pasienrj);
      }
    } catch (err) {
      console.error('Gagal mengambil data pasien:', err);
    } finally {
      setIsLoadingPasien(false);
    }
  };

  const handleOpenModal = () => {
    setShowModalPasien(true);
    setSearchPasienQuery('');
    fetchDaftarPasien();
  };

  const handleSelectPasien = (item) => {
    setNoMedrec(item.no_medrec);
    setNamaPasien(item.nama);
    setDokterPasien(item.nama_dok || '');
    setKdDokter(item.kd_dokter || item.nodok || '');
    setPenjaminPasien(item.prs_penjamin || '');
    setKlasifikasiPasien(item.nm_klasifikasi || '');
    setKdKlasifikasi(item.kd_klasifikasi || '');
    setKdKelas(item.kd_kelas || '01');
    
    if ((item.prs_penjamin || '').toLowerCase() === 'pribadi') {
      setCaraBayar('Tunai');
    } else {
      setCaraBayar('Piutang');
    }
    
    setShowModalPasien(false);
  };

  const [isPrinting, setIsPrinting] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [saveAlert, setSaveAlert] = useState({ show: false, variant: '', message: '' });
  const [showModalPrint, setShowModalPrint] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');

  const handleRincianSementara = async () => {
    if (!noMedrec) return;
    setIsPrinting(true);
    try {
      const payloadData = {
        no_medrec: noMedrec,
        no_nota: listTransaksi.length > 0 ? listTransaksi[0].no_nota : "-",
        nama_pasien: namaPasien,
        kelas: "Poliklinik",
        jaminan: penjaminPasien,
        ruang: "Poliklinik",
        penjamin: penjaminPasien,
        dokter: dokterPasien,
        perusahaan: "-",
        is_tunai: caraBayar === "Tunai" ? "1" : "0"
      };

      const fetchPdfArrayBuffer = async (endpoint) => {
        const res = await fetch(`${getApiUrl()}/${endpoint}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payloadData)
        });
        if (!res.ok) throw new Error(`HTTP Error from ${endpoint}`);
        
        const contentType = res.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          const json = await res.json();
          if (json.status === 1 || json.url) {
            const fileRes = await fetch(json.url);
            return await fileRes.arrayBuffer();
          }
          throw new Error(json.msg || `Gagal cetak dari ${endpoint}`);
        }
        return await res.arrayBuffer();
      };

      // Fetch both endpoints concurrently
      const results = await Promise.allSettled([
        fetchPdfArrayBuffer('cetak_rincian_sementara'),
        fetchPdfArrayBuffer('cetak_rincian_non_paket')
      ]);

      const [resSementara, resNonPaket] = results;

      if (resSementara.status === 'rejected' && resNonPaket.status === 'rejected') {
        throw new Error("Kedua permintaan cetak gagal.");
      }

      // Create a new merged PDF
      const mergedPdf = await PDFDocument.create();

      // Combine success results
      for (const res of [resSementara, resNonPaket]) {
        if (res.status === 'fulfilled' && res.value) {
          try {
            const pdfDoc = await PDFDocument.load(res.value);
            const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
            copiedPages.forEach((page) => mergedPdf.addPage(page));
          } catch (e) {
            console.warn("Gagal menggabungkan salah satu bagian dokumen PDF", e);
          }
        }
      }

      const mergedPdfBytes = await mergedPdf.save();
      const mergedBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(mergedBlob);
      
      setPdfUrl(url);
      setShowModalPrint(true);
      
    } catch (err) {
      console.error("Error cetak rincian:", err);
      alert("Terjadi kesalahan saat memproses rincian gabungan.");
    } finally {
      setIsPrinting(false);
    }
  };

  const handleBersih = () => {
    setNoMedrec('');
    setNamaPasien('');
    setDokterPasien('');
    setKdDokter('');
    setPenjaminPasien('');
    setKlasifikasiPasien('');
      setKdKlasifikasi('');
      setKdKelas('');
      setSelectedDokter(null);
      setSelectedKelompok(null);
      setSelectedTindakan(null);
    setCaraBayar('');
  };

  const filteredPasien = listPasien.filter(p => 
    (p.no_medrec && p.no_medrec.toLowerCase().includes(searchPasienQuery.toLowerCase())) ||
    (p.nama && p.nama.toLowerCase().includes(searchPasienQuery.toLowerCase())) ||
    (p.no_sep && p.no_sep.toLowerCase().includes(searchPasienQuery.toLowerCase()))
  );

    const handleSearchTindakan = async () => {
      if (!searchTindakanQuery || searchTindakanQuery.length < 2) {
        alert("Ketik minimal 2 huruf untuk mencari tindakan.");
        return;
      }
      setIsLoadingTindakan(true);
      const payload = new URLSearchParams({
        keyword: searchTindakanQuery,
        is_paket: '0',
        kd_klasifikasi: kdKlasifikasi || '',
        kd_kelas: '001',
        kd_kelompok: selectedKelompok ? selectedKelompok.value : ''
      });
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${getApiUrl()}/cari_tarif_tindakan_rj?token=${encodeURIComponent(token)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: payload.toString()
        });
        const json = await res.json();
        const dataArray = Array.isArray(json) ? json : (json.data || json.list_tindakan || []);
        setListTindakan(dataArray);
      } catch (err) {
        console.error("Error fetching tindakan:", err);
        setListTindakan([]);
      } finally {
        setIsLoadingTindakan(false);
      }
    };

    const handleSelectTindakan = (item) => {
      setSelectedTindakan({
        nama: item.nm_tindakan || item.nama,
        kode: item.kd_tindakan || item.kode,
        tarif: item.harga || item.tarif_total || item.tarif || item.total || 0,
        data: item
      });
      setInputQty(1);
      setShowModalTindakan(false);
    };

  const handleSimpanTindakan = async () => {
    if (!selectedTindakan) {
      setSaveAlert({ show: true, variant: 'warning', message: 'Pilih tindakan terlebih dahulu.' });
      return;
    }
    if (!selectedDokter) {
      setSaveAlert({ show: true, variant: 'warning', message: 'Pilih dokter pemberi layanan terlebih dahulu.' });
      return;
    }
    if (!selectedKelompok) {
      setSaveAlert({ show: true, variant: 'warning', message: 'Pilih klasifikasi pelayanan terlebih dahulu.' });
      return;
    }

    setIsSaving(true);
    setSaveAlert({ show: false, variant: '', message: '' });

    const token = localStorage.getItem('token');
    const userlogin = localStorage.getItem('userlogin') || localStorage.getItem('user') || 'kasir';
    const tindakanData = selectedTindakan.data || {};

    const payload = {
      txtmedrec: noMedrec,
      txtnonjm: '',
      txttglbukti2: time.date,
      txtkamar: 'POLI UMUM',
      txtkdtindakan2: selectedTindakan.kode,
      txtnmtindakan2: selectedTindakan.nama,
      txtkddokter2: selectedDokter ? selectedDokter.value : '',
      txtnmdokter2: selectedDokter ? selectedDokter.label : '',
      cmbpaket_index: '0',
      txtklasifikasi: kdKlasifikasi || '',
      txtkelas: '001',
      txtkelas2: '001',
      txtkdkelompok: selectedKelompok ? selectedKelompok.value : '',
      txtkode3: '',
      txtjumlah: inputQty,
      txtharga1: selectedTindakan.tarif,
      txttotal2: selectedTindakan.tarif * inputQty,
      xjasa: tindakanData.jasa || 0,
      xbahan: tindakanData.bahan || 0,
      xsewa: tindakanData.alat || 0,
      xparamedis: tindakanData.paramedis || 0,
      cektdkdijamin: false,
      xbhnnonresep: 'N',
      xselisih: 0,
      user_id: userlogin
    };

    try {
      const res = await fetch(`${getApiUrl()}/simpan_tindakan_rj?token=${encodeURIComponent(token)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const json = await res.json();
      if (json.status === 1 || json.status === '1') {
        setSaveAlert({ show: true, variant: 'success', message: json.msg || 'Tindakan berhasil disimpan!' });
        setSelectedDokter(null);
        setSelectedKelompok(null);
        setSelectedTindakan(null);
        setInputQty(1);
        if (noMedrec) {
          const r2 = await fetch(`${getApiUrl()}/show_transaksirj?no_medrec=${noMedrec}`);
          const j2 = await r2.json();
          if (j2.status === 1 && (j2.list_rincian || j2.list_rincain)) {
            setListTransaksi(j2.list_rincian || j2.list_rincain || []);
          }
        }
      } else {
        setSaveAlert({ show: true, variant: 'danger', message: json.msg || 'Gagal menyimpan tindakan.' });
      }
    } catch (err) {
      console.error('Error simpan tindakan:', err);
      setSaveAlert({ show: true, variant: 'danger', message: 'Terjadi kesalahan koneksi.' });
    } finally {
      setIsSaving(false);
    }
  };

  // Calculate Total Nota
  const totalNota = listTransaksi.reduce((acc, curr) => acc + (curr.total || 0), 0) + (selectedTindakan ? selectedTindakan.tarif * inputQty : 0);


  return (
    <div style={styles.appContainer}>
      {/* NAVBAR */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a className="navbar-brand d-flex align-items-center me-3" href="#home" onClick={(e) => { e.preventDefault(); navigate('/home'); }}>
            <div className="d-flex align-items-center justify-content-center me-2 rounded bg-white bg-opacity-10 p-1">
              <i className="bi bi-wallet2 text-warning fs-4"></i>
            </div>
            <div>
              <div className="fw-bold text-white lh-1" style={{ fontSize: '0.95rem' }}>SIMRS2 <span className="text-teal" style={{ fontSize: '0.78rem' }}>Billing</span></div>
              <div className="text-white-50 small" style={{ fontSize: '0.62rem' }}>Transaksi Poliklinik</div>
            </div>
          </a>

          <button 
            className="navbar-toggler" 
            type="button" 
            onClick={() => setIsNavOpen(!isNavOpen)}
            style={{ border: 'none', outline: 'none' }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 flex-row gap-2">
              {menus.map((item) => {
                const isActive = location.pathname.toLowerCase() === (item.lnk || '').toLowerCase() || (item.lnk === '/Polikonik' && location.pathname.toLowerCase() === '/poliklinik');
                return (
                  <li className="nav-item" key={item.id_mn}>
                    <a
                      className={`nav-link-custom ${isActive ? 'active' : ''}`}
                      href={`#${(item.des_mn || '').toLowerCase().replace(/\s+/g, '-')}`}
                      onClick={(e) => { 
                        e.preventDefault();
                        setActiveMenu(item.id_mn); 
                        setIsNavOpen(false);
                        if(item.lnk) {
                            if (item.lnk === '/Polikonik') navigate('/PoliKlinik');
                            else navigate(item.lnk);
                        }
                      }}
                      style={{ ...styles.navLinkCustom, ...(isActive ? styles.navLinkActive : {}) }}
                    >
                      <i className={`bi ${getMenuIcon(item.des_mn || '')}`}></i>
                      {(item.des_mn || '').toLowerCase().replace(/\b\w/g, s => s.toUpperCase())}
                    </a>
                  </li>
                );
              })}
            </ul>

            <div className="d-flex align-items-center text-white text-end gap-3 ms-auto">
              <div className="small border-end pe-3 border-light border-opacity-25 d-none d-lg-block">
                <div className="fw-semibold text-white-50" style={{ fontSize: '0.73rem' }}>{time.date}</div>
                <div className="fw-bold text-teal" style={{ fontSize: '0.78rem' }}>{time.clock}</div>
              </div>
              <div className="d-flex align-items-center gap-2">
                <div className="rounded-circle bg-white bg-opacity-25 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                  <i className="bi bi-person-fill text-white"></i>
                </div>
                <div className="text-start d-none d-md-block">
                  <div className="fw-bold lh-1" style={{ fontSize: '0.8rem' }}>{username}</div>
                  <div className="text-white-50" style={{ fontSize: '0.65rem' }}>Administrator</div>
                </div>
              </div>
              <Button
                variant="warning"
                size="sm"
                className="fw-semibold text-dark shadow-sm d-flex align-items-center gap-1"
                style={{ padding: '0.2rem 0.5rem', fontSize: '0.75rem', borderRadius: '6px' }}
                onClick={() => navigate('/home')}
              >
                <i className="bi bi-house-door-fill"></i> <span className="d-none d-sm-inline">Kembali ke Home</span>
              </Button>
            </div>
          </div>
        </Container>
      </nav>

      {/* CORE MAIN CONTENT */}
      <div style={styles.mainContent} className="d-flex flex-column bg-light">
        <Container fluid className="px-3 py-3 flex-grow-1 d-flex flex-column" style={{ minHeight: 0 }}>
          <Row className="flex-grow-1 g-3 m-0">
            
            {/* LEFT COLUMN: PATIENT & CART */}
            <Col lg={8} xl={9} className="d-flex flex-column h-100 p-0 pe-lg-3">
              
              {/* Identitas Pasien */}
              <Card className="border-0 shadow-sm mb-3" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                <Card.Header className="py-2 px-3 border-bottom-0" style={{ background: 'linear-gradient(90deg, #1e293b 0%, #334155 100%)', color: '#fff' }}>
                  <div className="d-flex align-items-center gap-2">
                    <div className="bg-white bg-opacity-25 text-white p-1 rounded shadow-sm d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px' }}>
                      <i className="bi bi-person-vcard-fill fs-6"></i>
                    </div>
                    <span className="fw-bold" style={{ fontSize: '0.85rem', letterSpacing: '0.5px' }}>IDENTITAS PASIEN</span>
                  </div>
                </Card.Header>
                <Card.Body className="p-3 pt-3">
                  <Row className="gy-2 align-items-center mb-2">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label className="text-muted fw-bold mb-1" style={{ fontSize: '0.7rem' }}>No. RM / KIRS</Form.Label>
                        <InputGroup size="sm">
                          <Form.Control 
                            type="text" 
                            readOnly 
                            value={noMedrec} 
                            placeholder="Pilih pasien..."
                            className="fw-bold bg-white text-primary" 
                            style={{ fontSize: '0.8rem' }} 
                          />
                          <Button variant="primary" onClick={handleOpenModal} className="d-flex align-items-center shadow-sm px-2">
                            <i className="bi bi-search"></i>
                          </Button>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col md={5}>
                      <Form.Group>
                        <Form.Label className="text-muted fw-bold mb-1" style={{ fontSize: '0.7rem' }}>Nama Lengkap Pasien</Form.Label>
                        <Form.Control 
                          type="text" 
                          readOnly 
                          value={namaPasien} 
                          placeholder="Belum ada pasien terpilih"
                          size="sm" 
                          className="fw-bold bg-white text-dark" 
                          style={{ cursor: 'not-allowed', fontSize: '0.8rem' }} 
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label className="text-muted fw-bold mb-1" style={{ fontSize: '0.7rem' }}>Ruangan</Form.Label>
                        <Form.Control 
                          type="text" 
                          readOnly 
                          value="Poliklinik" 
                          size="sm" 
                          className="fw-bold bg-light text-secondary" 
                          style={{ cursor: 'not-allowed', fontSize: '0.8rem' }} 
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="gy-2 align-items-center">
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-muted fw-bold mb-1" style={{ fontSize: '0.7rem' }}>Dokter Pemeriksa</Form.Label>
                          <Form.Control 
                            type="text" 
                            readOnly 
                            value={dokterPasien} 
                            placeholder="-"
                            size="sm" 
                            className="fw-bold bg-white text-dark" 
                            style={{ cursor: 'not-allowed', fontSize: '0.8rem' }} 
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-muted fw-bold mb-1" style={{ fontSize: '0.7rem' }}>Klasifikasi</Form.Label>
                          <Form.Control 
                            type="text" 
                            readOnly 
                            value={klasifikasiPasien} 
                            placeholder="-"
                            size="sm" 
                            className="fw-bold bg-white text-dark" 
                            style={{ cursor: 'not-allowed', fontSize: '0.8rem' }} 
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-muted fw-bold mb-1" style={{ fontSize: '0.7rem' }}>Penjamin</Form.Label>
                          <Form.Control 
                            type="text" 
                            readOnly 
                            value={penjaminPasien} 
                            placeholder="-"
                            size="sm" 
                            className="fw-bold bg-white text-dark" 
                            style={{ cursor: 'not-allowed', fontSize: '0.8rem' }} 
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-muted fw-bold mb-1" style={{ fontSize: '0.7rem' }}>Cara Bayar</Form.Label>
                          <Form.Select 
                            size="sm" 
                            value={caraBayar}
                            onChange={(e) => setCaraBayar(e.target.value)}
                            className="fw-bold text-dark border"
                            style={{ fontSize: '0.8rem' }}
                          >
                            <option value="">- Pilih -</option>
                            <option value="Tunai">Tunai</option>
                            <option value="Piutang">Piutang</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                </Card.Body>
              </Card>

              {/* Cart Table */}
              <Card className="border-0 shadow-sm flex-grow-1 d-flex flex-column" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                <Card.Header className="bg-white border-bottom py-2 px-3 d-flex justify-content-between align-items-center">
                  <div className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>
                    <i className="bi bi-cart3 text-teal me-2 fs-6"></i> RINCIAN TAGIHAN
                  </div>
                  <Badge bg="light" text="secondary" className="border fw-semibold px-2 py-1">
                    {listTransaksi.length} Item
                  </Badge>
                </Card.Header>
                <div className="table-responsive flex-grow-1 bg-white" style={{ minHeight: '300px' }}>
                  <Table hover className="align-middle mb-0" size="sm" borderless>
                    <thead style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                      <tr>
                        <th className="text-center text-secondary fw-semibold py-2" style={{ width: '5%', fontSize: '0.75rem', letterSpacing: '0.5px' }}>NO</th>
                        <th className="text-secondary fw-semibold py-2 px-3" style={{ width: '45%', fontSize: '0.75rem', letterSpacing: '0.5px' }}>DESKRIPSI TINDAKAN</th>
                        <th className="text-center text-secondary fw-semibold py-2" style={{ width: '15%', fontSize: '0.75rem', letterSpacing: '0.5px' }}>NO. NOTA</th>
                        <th className="text-end text-secondary fw-semibold py-2 pe-4" style={{ width: '20%', fontSize: '0.75rem', letterSpacing: '0.5px' }}>TARIF (Rp)</th>
                        <th className="text-center text-secondary fw-semibold py-2" style={{ width: '15%', fontSize: '0.75rem', letterSpacing: '0.5px' }}>AKSI</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoadingTransaksi ? (
                        <tr>
                          <td colSpan="5" className="text-center py-5">
                            <Spinner animation="border" variant="primary" size="sm" />
                            <div className="mt-2 text-muted fw-semibold" style={{ fontSize: '0.8rem' }}>Memuat rincian transaksi...</div>
                          </td>
                        </tr>
                      ) : listTransaksi.length > 0 ? (
                        listTransaksi.map((item, idx) => (
                          <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                            <td className="text-center align-middle fw-semibold text-muted py-1" style={{ fontSize: '0.8rem' }}>{idx + 1}</td>
                            <td className="align-middle py-1 px-3">
                              <div className="fw-bold text-dark mb-0" style={{ fontSize: '0.85rem' }}>{item.nm_tindakan}</div>
                              <div className="d-flex gap-2 mt-1">
                                <span className="badge bg-light text-secondary border fw-normal" style={{ fontSize: '0.65rem' }}>Kode: {item.kd_tindakan}</span>
                                <span className="badge bg-light text-primary border fw-normal" style={{ fontSize: '0.65rem' }}>BPJS: Rp {item.bpjs?.toLocaleString('id-ID')}</span>
                              </div>
                            </td>
                            <td className="text-center align-middle fw-semibold text-secondary py-1" style={{ fontSize: '0.8rem' }}>{item.no_nota}</td>
                            <td className="text-end align-middle fw-bold text-dark py-1 pe-4" style={{ fontSize: '0.85rem' }}>
                              {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(item.total)}
                            </td>
                            <td className="text-center align-middle py-1">
                              <Button variant="outline-danger" size="sm" className="shadow-none border-0" style={{ padding: '0.3rem 0.5rem', borderRadius: '6px' }}>
                                <i className="bi bi-trash3-fill"></i>
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            <div className="d-flex flex-column align-items-center justify-content-center text-muted my-4">
                              <div className="bg-light p-3 rounded-circle mb-3 shadow-sm border border-white">
                                <i className="bi bi-cart-x fs-1 text-secondary opacity-75"></i>
                              </div>
                              <h6 className="fw-bold text-dark mb-1" style={{ fontSize: '0.9rem' }}>Belum ada rincian kuitansi</h6>
                              <p className="mb-0 text-muted" style={{ fontSize: '0.8rem' }}>Silakan cari pasien untuk menarik data transaksi.</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Card>
            </Col>

            {/* RIGHT COLUMN: POS CHECKOUT PANEL */}
            <Col lg={4} xl={3} className="d-flex flex-column h-100 p-0">
              
              {/* Digital Total Display */}
              <Card className="border-0 shadow-sm mb-3" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)' }}>
                <Card.Body className="p-4 d-flex flex-column justify-content-center text-end">
                  <div className="text-white-50 fw-bold mb-1" style={{ fontSize: '0.8rem', letterSpacing: '1px' }}>TOTAL TAGIHAN</div>
                  <div className="fw-bolder text-success text-truncate" style={{ fontSize: '2.5rem', lineHeight: '1.2' }}>
                    {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(totalTagihan)}
                  </div>
                </Card.Body>
              </Card>

              {/* Summary & Status */}
              <Card className="border-0 shadow-sm mb-3" style={{ borderRadius: '12px' }}>
                <Card.Body className="p-3">
                  <div className="d-flex justify-content-between align-items-center mb-2" style={{ fontSize: '0.85rem' }}>
                    <span className="text-muted fw-semibold">Sub Total</span>
                    <span className="fw-bold text-dark">{new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(subTotal)}</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3 text-danger" style={{ fontSize: '0.85rem' }}>
                    <span className="fw-semibold">Diskon</span>
                    <span className="fw-bold">- {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(diskon)}</span>
                  </div>
                  <Badge bg="warning" text="dark" className="w-100 py-2 d-flex justify-content-center align-items-center gap-2 shadow-sm" style={{ fontSize: '0.75rem' }}>
                    <i className="bi bi-exclamation-triangle-fill text-danger fs-6"></i> STATUS KODING: BELUM VERIFIKASI
                  </Badge>
                </Card.Body>
              </Card>

              {/* POS Controls */}
              <Card className="border-0 shadow-sm flex-grow-1 d-flex flex-column" style={{ borderRadius: '12px' }}>
                <Card.Body className="p-3 d-flex flex-column gap-2">
                  <div className="fw-bold text-muted mb-2 text-center" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>TINDAKAN CEPAT</div>
                  
                  <Button variant="outline-primary" size="sm" className="w-100 text-start fw-semibold py-2 px-3 d-flex align-items-center" disabled={!noMedrec} onClick={() => setShowModalTT(true)}>
                    <i className="bi bi-cloud-arrow-down-fill me-2 fs-6"></i> Ambil Transaksi TT
                  </Button>
                  <Button variant="outline-info" size="sm" className="w-100 text-start fw-semibold text-dark py-2 px-3 d-flex align-items-center" disabled={!noMedrec || isPrinting} onClick={handleRincianSementara}>
                    {isPrinting ? <Spinner animation="border" size="sm" className="me-2 text-info" /> : <i className="bi bi-file-earmark-medical-fill me-2 fs-6 text-info"></i>}
                    Rincian Sementara
                  </Button>
                  {isPrinting && (
                    <div className="px-1 mt-1 mb-2">
                      <div className="d-flex justify-content-between text-info fw-bold mb-1" style={{ fontSize: '0.65rem' }}>
                        <span>Memproses Dokumen...</span>
                      </div>
                      <ProgressBar animated now={100} variant="info" style={{ height: '6px' }} />
                    </div>
                  )}
                  <Button variant="outline-secondary" size="sm" className="w-100 text-start fw-semibold py-2 px-3 d-flex align-items-center" disabled={!noMedrec} onClick={() => setShowModalTransaksi(true)}>
                    <i className="bi bi-person-lines-fill me-2 fs-6 text-secondary"></i> Transaksi Pasien
                  </Button>
                  <Button variant="outline-dark" size="sm" className="w-100 text-start fw-semibold py-2 px-3 d-flex align-items-center" disabled={!noMedrec}>
                    <i className="bi bi-upc-scan me-2 fs-6 text-dark"></i> Koding INA-CBG
                  </Button>
                  <Button variant="outline-success" size="sm" className="w-100 text-start fw-semibold py-2 px-3 d-flex align-items-center text-dark" onClick={() => navigate('/KasKasir', { state: { from: '/PoliKlinik' } })}>
                    <i className="bi bi-journal-text me-2 fs-6 text-success"></i> Buku Kas Kasir
                  </Button>

                  <div className="mt-auto pt-3 border-top d-flex gap-2">
                      <Button variant="light" className="fw-bold text-danger border shadow-sm d-flex justify-content-center align-items-center gap-2" onClick={handleBersih} style={{ fontSize: '0.8rem', padding: '0.5rem', flex: 1, borderRadius: '6px' }}>
                        <i className="bi bi-arrow-counterclockwise fs-6"></i> BERSIH
                      </Button>
                      <Button 
                        className="fw-bolder d-flex justify-content-center align-items-center gap-2 border-0" 
                        disabled={!noMedrec} 
                        style={{ 
                          flex: 2,
                          fontSize: '0.9rem', 
                          padding: '0.5rem',
                          background: noMedrec ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)' : '#e2e8f0',
                          color: noMedrec ? '#ffffff' : '#94a3b8',
                          borderRadius: '8px',
                          boxShadow: noMedrec ? '0 4px 10px -3px rgba(16,185,129,0.4)' : 'none',
                          transition: 'all 0.2s ease',
                          letterSpacing: '1px'
                        }}
                        onMouseEnter={(e) => {
                          if (noMedrec) {
                            e.currentTarget.style.transform = 'translateY(-1px)';
                            e.currentTarget.style.boxShadow = '0 6px 15px -4px rgba(16,185,129,0.5)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (noMedrec) {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 10px -3px rgba(16,185,129,0.4)';
                          }
                        }}
                      >
                        <i className="bi bi-wallet2 fs-5 me-1"></i> BAYAR
                      </Button>
                    </div>
                  </Card.Body>
              </Card>

            </Col>
          </Row>
        </Container>
      </div>

      {/* MODAL PILIH PASIEN */}
      <Modal show={showModalPasien} onHide={() => setShowModalPasien(false)} size="lg" centered>
        <Modal.Header closeButton className="bg-primary text-white py-2">
          <Modal.Title style={{ fontSize: '1rem' }}><i className="bi bi-people-fill me-2"></i>Daftar Pasien Poliklinik Hari Ini</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light p-3">
          <InputGroup className="mb-3 shadow-sm">
            <InputGroup.Text className="bg-white"><i className="bi bi-search text-muted"></i></InputGroup.Text>
            <Form.Control
              placeholder="Cari berdasarkan No. RM, Nama, atau No. SEP..."
              value={searchPasienQuery}
              onChange={(e) => setSearchPasienQuery(e.target.value)}
            />
          </InputGroup>

          <Card className="border-0 shadow-sm" style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <Table hover responsive className="align-middle mb-0" size="sm" style={{ fontSize: '0.8rem' }}>
              <thead className="table-light border-bottom sticky-top">
                <tr>
                  <th>No. RM</th>
                  <th>Nama Pasien</th>
                  <th>Klinik / Dokter</th>
                  <th>Penjamin</th>
                  <th className="text-center">Aksi</th>
                </tr>
              </thead>
              <tbody>
                {isLoadingPasien ? (
                  <tr>
                    <td colSpan="5" className="text-center py-4 text-muted">
                      <Spinner animation="border" size="sm" className="me-2" />
                      Memuat daftar pasien...
                    </td>
                  </tr>
                ) : filteredPasien.length > 0 ? (
                  filteredPasien.map((item, idx) => (
                    <tr key={idx} style={{ cursor: 'pointer' }} onClick={() => handleSelectPasien(item)}>
                      <td className="fw-bold text-primary">{item.no_medrec}</td>
                      <td className="fw-semibold text-dark">{item.nama}</td>
                      <td>
                        <div className="text-dark">{item.nm_klasifikasi}</div>
                        <div className="text-muted" style={{ fontSize: '0.7rem' }}>{item.nama_dok}</div>
                      </td>
                      <td>
                        <Badge bg="info" className="text-dark">{item.prs_penjamin}</Badge>
                      </td>
                      <td className="text-center">
                        <Button variant="primary" size="sm" className="py-0 px-2" onClick={(e) => {
                          e.stopPropagation();
                          handleSelectPasien(item);
                        }}>Pilih</Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-4 text-muted">
                      Tidak ada pasien yang sesuai.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card>
        </Modal.Body>
      </Modal>

      {/* MODAL TRANSAKSI PASIEN */}
      <Modal show={showModalTransaksi} onHide={() => setShowModalTransaksi(false)} size="xl" centered backdrop="static" keyboard={true}>
        {/* Modern Header */}
        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)', padding: '1rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderRadius: '0.375rem 0.375rem 0 0' }}>
          <div className="d-flex align-items-center gap-3">
            <div style={{ background: 'rgba(13,148,136,0.3)', borderRadius: '8px', padding: '8px 10px' }}>
              <i className="bi bi-receipt-cutoff text-white fs-5"></i>
            </div>
            <div>
              <div className="fw-bold text-white" style={{ fontSize: '0.95rem', letterSpacing: '0.3px' }}>KASIR RAWAT JALAN POLIKLINIK</div>
              <div className="text-white-50" style={{ fontSize: '0.72rem' }}>{namaPasien} — No. RM: {noMedrec}</div>
            </div>
          </div>
          <button className="btn-close btn-close-white" onClick={() => setShowModalTransaksi(false)}></button>
        </div>

        <Modal.Body className="p-0 bg-light" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
          
          {/* Info Bar */}
          <div style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '0.6rem 1.25rem' }} className="d-flex gap-4 align-items-center">
            <div className="d-flex align-items-center gap-2">
              <span className="text-muted" style={{ fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.5px' }}>NO. NOTA</span>
              <Form.Control size="sm" className="fw-bold border-0 bg-light text-primary" style={{ fontSize: '0.82rem', width: '90px', padding: '2px 8px' }} placeholder="Auto" />
            </div>
            <div className="vr opacity-25"></div>
            <div className="d-flex align-items-center gap-2">
              <span className="text-muted" style={{ fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.5px' }}>TGL TRANSAKSI</span>
              <span className="fw-semibold text-dark" style={{ fontSize: '0.82rem' }}>{time.date}</span>
            </div>
            <div className="vr opacity-25"></div>
            <div className="d-flex align-items-center gap-2">
              <span className="text-muted" style={{ fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.5px' }}>JENIS NOTA</span>
              <Form.Select size="sm" className="border-0 bg-light fw-semibold text-dark" style={{ fontSize: '0.82rem', padding: '2px 8px', width: '100px' }}>
                <option value="Normal">Normal</option>
                <option value="Paket">Paket</option>
              </Form.Select>
            </div>
            <div className="vr opacity-25"></div>
            <div className="d-flex align-items-center gap-2 ms-auto">
              <Form.Check type="checkbox" id="check-buku-tarif" className="me-1" />
              <label htmlFor="check-buku-tarif" className="text-danger fw-semibold mb-0" style={{ fontSize: '0.78rem', cursor: 'pointer' }}>
                <i className="bi bi-exclamation-triangle-fill me-1"></i>Buku Tarif Pribadi
              </label>
            </div>
          </div>

          {/* Save Alert */}
          {saveAlert.show && (
            <div className={`alert alert-${saveAlert.variant} alert-dismissible d-flex align-items-center py-2 px-3 mx-0 mb-0 rounded-0`} style={{ fontSize: '0.82rem' }}>
              <i className={`bi bi-${saveAlert.variant === 'success' ? 'check-circle-fill' : saveAlert.variant === 'warning' ? 'exclamation-triangle-fill' : 'x-circle-fill'} me-2`}></i>
              {saveAlert.message}
              <button type="button" className="btn-close ms-auto py-1" style={{ fontSize: '0.7rem' }} onClick={() => setSaveAlert({ show: false, variant: '', message: '' })}></button>
            </div>
          )}

          {/* Input Entry Row */}
          <div style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0', padding: '0.5rem 0' }}>
            <table className="table table-sm align-middle mb-0" style={{ fontSize: '0.8rem' }}>
              <thead>
                <tr>
                  <th className="text-uppercase text-muted fw-semibold py-2 ps-3" style={{ fontSize: '0.68rem', letterSpacing: '0.5px', width: '22%' }}>Dokter Pemberi Layanan</th>
                  <th className="text-uppercase text-muted fw-semibold py-2" style={{ fontSize: '0.68rem', letterSpacing: '0.5px', width: '18%' }}>Klasifikasi</th>
                  <th className="text-uppercase text-muted fw-semibold py-2" style={{ fontSize: '0.68rem', letterSpacing: '0.5px', width: '28%' }}>Tindakan</th>
                  <th className="text-uppercase text-muted fw-semibold py-2 text-end" style={{ fontSize: '0.68rem', letterSpacing: '0.5px', width: '12%' }}>Tarif</th>
                  <th className="text-uppercase text-muted fw-semibold py-2 text-center" style={{ fontSize: '0.68rem', letterSpacing: '0.5px', width: '8%' }}>Qty</th>
                  <th className="text-uppercase text-muted fw-semibold py-2 text-end pe-3" style={{ fontSize: '0.68rem', letterSpacing: '0.5px', width: '12%' }}>Jumlah</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-white">
                  <td className="ps-3 py-2" style={{ minWidth: '170px' }}>
                    <Select
                      options={dokterOptions}
                      value={selectedDokter}
                      onChange={(val) => setSelectedDokter(val)}
                      placeholder={isLoadingDokter ? "Memuat..." : "Cari dokter..."}
                      isSearchable
                      isLoading={isLoadingDokter}
                      menuPortalTarget={document.body}
                      styles={{
                        control: (base) => ({ ...base, minHeight: '30px', height: '30px', fontSize: '0.8rem', borderColor: '#dee2e6', boxShadow: 'none', '&:hover': { borderColor: '#0d9488' } }),
                        valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                        indicatorsContainer: (base) => ({ ...base, height: '30px' }),
                        option: (base, state) => ({ ...base, fontSize: '0.8rem', padding: '6px 10px', backgroundColor: state.isSelected ? '#0d9488' : state.isFocused ? '#f0fdf4' : 'white', color: state.isSelected ? 'white' : '#333' }),
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </td>
                  <td className="py-2" style={{ minWidth: '150px' }}>
                    <Select
                      options={kelompokOptions}
                      value={selectedKelompok}
                      onChange={(val) => { setSelectedKelompok(val); setSelectedTindakan(null); }}
                      placeholder={isLoadingKelompok ? "Memuat..." : "Pilih klasifikasi..."}
                      isSearchable
                      isLoading={isLoadingKelompok}
                      menuPortalTarget={document.body}
                      styles={{
                        control: (base) => ({ ...base, minHeight: '30px', height: '30px', fontSize: '0.8rem', borderColor: '#dee2e6', boxShadow: 'none', '&:hover': { borderColor: '#0d9488' } }),
                        valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                        indicatorsContainer: (base) => ({ ...base, height: '30px' }),
                        option: (base, state) => ({ ...base, fontSize: '0.8rem', padding: '6px 10px', backgroundColor: state.isSelected ? '#0d9488' : state.isFocused ? '#f0fdf4' : 'white', color: state.isSelected ? 'white' : '#333' }),
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </td>
                  <td className="py-2" style={{ minWidth: '200px' }}>
                    <InputGroup size="sm">
                      <Form.Control
                        placeholder={!selectedKelompok ? "Pilih klasifikasi dulu..." : "Klik untuk cari tindakan..."}
                        readOnly
                        disabled={!selectedKelompok}
                        style={{ fontSize: '0.8rem', cursor: !selectedKelompok ? 'not-allowed' : 'pointer', backgroundColor: !selectedKelompok ? '#f1f5f9' : '#fff', borderRight: 'none' }}
                        onClick={() => { if (selectedKelompok) setShowModalTindakan(true); }}
                        value={selectedTindakan ? selectedTindakan.nama : ''}
                      />
                      <Button
                        variant={selectedKelompok ? "outline-primary" : "outline-secondary"}
                        disabled={!selectedKelompok}
                        onClick={() => { if (selectedKelompok) setShowModalTindakan(true); }}
                        style={{ borderLeft: 'none' }}
                      >
                        <i className="bi bi-search" style={{ fontSize: '0.75rem' }}></i>
                      </Button>
                    </InputGroup>
                  </td>
                  <td className="text-end fw-bold py-2 pe-2" style={{ fontSize: '0.85rem', color: selectedTindakan ? '#0f766e' : '#94a3b8' }}>
                    {selectedTindakan ? selectedTindakan.tarif.toLocaleString('id-ID') : '—'}
                  </td>
                  <td className="text-center py-2" style={{ width: '80px' }}>
                    <Form.Control
                      type="number"
                      min="1"
                      size="sm"
                      value={inputQty}
                      onChange={(e) => setInputQty(parseInt(e.target.value) || 1)}
                      className="text-center fw-bold"
                      style={{ fontSize: '0.85rem', padding: '2px 4px', borderColor: '#dee2e6' }}
                    />
                  </td>
                  <td className="text-end fw-bold pe-3 py-2" style={{ fontSize: '0.9rem', color: selectedTindakan ? '#059669' : '#94a3b8' }}>
                    {selectedTindakan ? (selectedTindakan.tarif * inputQty).toLocaleString('id-ID') : '—'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Existing Transactions */}
          <div style={{ padding: '0.75rem 1.25rem' }}>
            <div className="d-flex align-items-center justify-content-between mb-2">
              <span className="fw-bold text-dark" style={{ fontSize: '0.78rem', letterSpacing: '0.3px' }}>
                <i className="bi bi-list-check me-1 text-primary"></i>RINCIAN TAGIHAN EXISTING
              </span>
              <Badge bg="secondary" className="fw-normal">{listTransaksi.length} item</Badge>
            </div>
            <div style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #e2e8f0', background: '#fff' }}>
              <table className="table table-sm align-middle mb-0" style={{ fontSize: '0.82rem' }}>
                <thead style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  <tr>
                    <th className="py-2 ps-3 text-muted fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.4px', width: '5%' }}>#</th>
                    <th className="py-2 text-muted fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.4px', width: '45%' }}>DESKRIPSI TINDAKAN</th>
                    <th className="py-2 text-center text-muted fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.4px', width: '15%' }}>NO. NOTA</th>
                    <th className="py-2 text-end text-muted fw-semibold pe-3" style={{ fontSize: '0.7rem', letterSpacing: '0.4px', width: '20%' }}>TARIF (Rp)</th>
                    <th className="py-2 text-center text-muted fw-semibold" style={{ fontSize: '0.7rem', letterSpacing: '0.4px', width: '15%' }}>AKSI</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoadingTransaksi ? (
                    <tr><td colSpan="5" className="text-center py-4"><Spinner animation="border" variant="primary" size="sm" /><div className="mt-2 text-muted" style={{ fontSize: '0.8rem' }}>Memuat rincian...</div></td></tr>
                  ) : listTransaksi.length > 0 ? (
                    listTransaksi.map((item, idx) => (
                      <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td className="ps-3 text-muted fw-semibold" style={{ fontSize: '0.8rem' }}>{idx + 1}</td>
                        <td className="py-2">
                          <div className="fw-bold text-dark" style={{ fontSize: '0.82rem' }}>{item.nm_tindakan}</div>
                          <div className="d-flex gap-2 mt-1">
                            <span className="badge bg-light text-secondary border fw-normal" style={{ fontSize: '0.62rem' }}>Kode: {item.kd_tindakan}</span>
                          </div>
                        </td>
                        <td className="text-center fw-semibold text-secondary" style={{ fontSize: '0.8rem' }}>{item.no_nota}</td>
                        <td className="text-end fw-bold text-dark pe-3" style={{ fontSize: '0.82rem' }}>
                          {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(item.total)}
                        </td>
                        <td className="text-center">
                          <Button variant="outline-danger" size="sm" className="border-0 shadow-none" style={{ padding: '2px 8px', borderRadius: '6px' }}>
                            <i className="bi bi-trash3-fill" style={{ fontSize: '0.75rem' }}></i>
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-4 text-muted" style={{ fontSize: '0.82rem' }}>
                        <i className="bi bi-inbox fs-4 d-block mb-1 text-secondary opacity-50"></i>
                        Belum ada rincian tagihan
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

        </Modal.Body>

        {/* Modern Footer */}
        <div style={{ background: '#fff', borderTop: '1px solid #e2e8f0', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderRadius: '0 0 0.375rem 0.375rem' }}>
          <div className="d-flex align-items-center gap-3">
            <span className="text-muted" style={{ fontSize: '0.72rem' }}>Tekan <kbd className="bg-light text-dark border">Esc</kbd> untuk menutup</span>
          </div>
          <div className="d-flex align-items-center gap-3">
            <div className="text-end">
              <div className="text-muted fw-semibold" style={{ fontSize: '0.68rem', letterSpacing: '0.5px' }}>TOTAL NOTA</div>
              <div className="fw-bolder text-success" style={{ fontSize: '1.3rem', lineHeight: 1.1 }}>
                {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(totalNota)}
              </div>
            </div>
            <div className="vr opacity-25 mx-1" style={{ height: '40px' }}></div>
            <Button
              variant="success"
              className="fw-bold px-4 shadow-sm d-flex align-items-center gap-2"
              style={{ background: 'linear-gradient(135deg, #059669, #0d9488)', border: 'none', borderRadius: '8px', height: '44px', fontSize: '0.9rem' }}
              onClick={handleSimpanTindakan}
              disabled={isSaving || !selectedTindakan}
            >
              {isSaving ? (
                <><Spinner animation="border" size="sm" className="me-1" /> Menyimpan...</>
              ) : (
                <><i className="bi bi-check2-circle fs-5"></i> SIMPAN & PROSES</>
              )}
            </Button>
          </div>
        </div>
      </Modal>


      {/* MODAL CARI TINDAKAN */}
      <Modal show={showModalTindakan} onHide={() => setShowModalTindakan(false)} size="xl" centered>
        <Modal.Header closeButton className="bg-primary text-white py-2">
          <Modal.Title style={{ fontSize: '1rem' }}><i className="bi bi-search me-2"></i>Pencarian Tarif Tindakan</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light p-3">
          <InputGroup className="mb-3 shadow-sm">
            <InputGroup.Text className="bg-white"><i className="bi bi-search text-muted"></i></InputGroup.Text>
            <Form.Control
              placeholder="Ketik kata kunci nama atau kode tindakan, lalu tekan Enter..."
              value={searchTindakanQuery}
              onChange={(e) => setSearchTindakanQuery(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleSearchTindakan(); }}
              autoFocus
            />
            <Button variant="primary" onClick={handleSearchTindakan}>Cari</Button>
          </InputGroup>
          
          <Card className="border-0 shadow-sm overflow-hidden">
            <Table hover responsive className="mb-0" size="sm" style={{ fontSize: '0.85rem' }}>
              <thead className="bg-light text-muted">
                <tr>
                  <th className="py-2 px-3" style={{ width: '10%' }}>KODE</th>
                  <th className="py-2" style={{ width: '30%' }}>NAMA TINDAKAN</th>
                  <th className="py-2 text-end" style={{ width: '10%' }}>JASA</th>
                  <th className="py-2 text-end" style={{ width: '10%' }}>PARAMEDIS</th>
                  <th className="py-2 text-end" style={{ width: '10%' }}>BAHAN</th>
                  <th className="py-2 text-end" style={{ width: '10%' }}>ALAT</th>
                  <th className="py-2 text-end" style={{ width: '12%' }}>HARGA (Rp)</th>
                  <th className="py-2 text-center" style={{ width: '8%' }}>AKSI</th>
                </tr>
              </thead>
              <tbody>
                {isLoadingTindakan ? (
                  <tr>
                    <td colSpan="8" className="text-center py-4">
                      <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                      Mencari data...
                    </td>
                  </tr>
                ) : listTindakan.length > 0 ? (
                  listTindakan.map((item, idx) => (
                    <tr key={idx} style={{ cursor: 'pointer' }} onClick={() => handleSelectTindakan(item)}>
                      <td className="px-3 fw-bold text-primary">{item.kd_tindakan || item.kode}</td>
                      <td className="fw-semibold text-dark">{item.nm_tindakan || item.nama}</td>
                      <td className="text-end text-muted">{(item.jasa || item.jasa_dokter || 0).toLocaleString('id-ID')}</td>
                      <td className="text-end text-muted">{(item.paramedis || item.jasa_paramedis || 0).toLocaleString('id-ID')}</td>
                      <td className="text-end text-muted">{(item.bahan || 0).toLocaleString('id-ID')}</td>
                      <td className="text-end text-muted">{(item.alat || 0).toLocaleString('id-ID')}</td>
                      <td className="text-end fw-bold text-success">Rp {(item.harga || item.tarif_total || item.tarif || item.total || 0).toLocaleString('id-ID')}</td>
                      <td className="text-center">
                        <Button variant="primary" size="sm" className="py-0 px-2" onClick={(e) => { e.stopPropagation(); handleSelectTindakan(item); }}>Pilih</Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-4 text-muted">
                      Tidak ada tindakan yang sesuai.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card>
        </Modal.Body>
      </Modal>

      {/* MODAL INPUT TRANSAKSI TT */}
      <Modal show={showModalTT} onHide={() => setShowModalTT(false)} centered size="sm">
        <Modal.Header closeButton className="py-2 text-white" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)' }}>
          <Modal.Title style={{ fontSize: '0.9rem', letterSpacing: '0.3px' }} className="fw-bold">
            <i className="bi bi-search me-2 text-warning"></i>Cari Transaksi TT
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light p-3">
          <Form.Group>
            <Form.Label className="text-muted fw-bold mb-1" style={{ fontSize: '0.75rem' }}>Nomor Transaksi TT</Form.Label>
            <Form.Control 
              type="text" 
              placeholder="Masukkan nomor..." 
              value={inputNoTT} 
              onChange={(e) => setInputNoTT(e.target.value)} 
              autoFocus
              className="fw-bold text-primary"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="py-2 px-3 border-top bg-white d-flex justify-content-end gap-2">
          <Button variant="light" size="sm" onClick={() => setShowModalTT(false)} className="border fw-semibold text-danger">Batal</Button>
          <Button variant="primary" size="sm" onClick={handleProsesTT} className="fw-bold px-3">Proses</Button>
          </Modal.Footer>
      </Modal>


      {/* MODAL PRINT PREVIEW */}
      <Modal size="xl" show={showModalPrint} onHide={() => setShowModalPrint(false)} centered>
        <Modal.Header closeButton className="bg-light border-bottom py-2">
          <Modal.Title className="fw-bold" style={{ fontSize: '1rem' }}>
            <i className="bi bi-printer text-primary me-2"></i> Pratinjau Rincian Sementara
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0" style={{ height: '75vh' }}>
          {pdfUrl ? (
            <iframe src={pdfUrl} width="100%" height="100%" style={{ border: 'none' }} title="Print Preview" />
          ) : (
            <div className="d-flex justify-content-center align-items-center h-100">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
        </Modal.Body>
      </Modal>

    </div>
  );
};

export default PoliKlinik;
